function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6,344.51c0-1.92-.11-3.82-.13-5.7l.28.28c-4.54.05-9.09.16-13.63.17l-13.63.06.51-.51,0,11.52-.46-.46c2.24,0,4.48,0,6.74.06L77,350l13.75.29Zm-13.36,6.1-6.86.12c-2.29,0-4.59,0-6.89.06H63v-.46L63,338.81v-.52h.52l13.63.07c4.54,0,9.09.11,13.63.17H91v.28c0,1.95-.09,3.9-.13,5.82l-.15,5.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4,359c-.05-1.92-.12-3.81-.14-5.7l.28.28c-4.54.06-9.08.17-13.63.17l-13.63.07.52-.52-.06,11.52-.46-.46c2.25,0,4.49,0,6.74.06l6.77.12,13.75.28ZM62,365.14l-6.86.11c-2.29.05-4.59,0-6.89.06h-.46v-.47l0-11.52v-.51h.52l13.63.06c4.55,0,9.09.12,13.63.17h.29v.27c0,2-.09,3.9-.13,5.82l-.15,5.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81,359c0-1.92-.12-3.81-.14-5.7l.29.28c-4.55.06-9.09.17-13.63.17l-13.63.07.51-.52-.06,11.52-.45-.46c2.24,0,4.48,0,6.73.06l6.78.12,13.75.28Zm-13.37,6.11-6.85.11c-2.29.05-4.6,0-6.89.06h-.46v-.47l-.06-11.52v-.51h.52l13.63.06c4.54,0,9.08.12,13.63.17h.28v.27c0,2-.09,3.9-.14,5.82l-.14,5.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.6,359c-.05-1.92-.12-3.81-.14-5.7l.28.28c-4.54.06-9.08.17-13.63.17l-13.63.07.52-.52-.06,11.52-.46-.46c2.25,0,4.49,0,6.74.06l6.78.12,13.74.28Zm-13.37,6.11-6.85.11c-2.3.05-4.6,0-6.9.06H409v-.47L409,353.33v-.51h.51l13.63.06c4.55,0,9.09.12,13.63.17H437v.27c0,2-.09,3.9-.14,5.82l-.15,5.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.6,55c-.05-1.92-.12-3.81-.14-5.7l.28.28c-4.54.05-9.08.16-13.63.17l-13.63.06.52-.51-.06,11.52-.46-.46c2.25,0,4.49,0,6.74.06l6.78.11,13.74.29Zm-13.37,6.11-6.85.11c-2.3.05-4.6,0-6.9.06H409v-.46L409,49.34v-.52h.51l13.63.06c4.55,0,9.09.12,13.63.17H437v.28c0,1.95-.09,3.9-.14,5.82l-.15,5.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.81,69.56c-.05-1.91-.12-3.81-.14-5.69l.28.28c-4.54,0-9.09.16-13.63.16l-13.63.07.51-.51-.05,11.51-.46-.45c2.25,0,4.49,0,6.74,0l6.77.12,13.75.28Zm-13.37,6.11-6.86.12c-2.29,0-4.59,0-6.89,0h-.46v-.47l-.05-11.51v-.52h.52l13.63.07c4.54,0,9.09.11,13.63.16h.29v.28c0,1.95-.09,3.89-.13,5.82L452,75.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4,55.05c-.05-1.92-.12-3.81-.14-5.7l.28.28c-4.54.06-9.08.17-13.63.17l-13.63.07.52-.52-.06,11.52-.46-.46c2.25,0,4.49,0,6.74.06l6.77.11,13.75.29ZM62,61.16l-6.86.11c-2.29,0-4.59,0-6.89.06h-.46v-.46l0-11.52v-.51h.52l13.63.06c4.55,0,9.09.12,13.63.17h.29v.28c0,2-.09,3.9-.13,5.82l-.15,5.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.64,327.23c.05,1.92.12,3.82.13,5.7l-.28-.28c4.55,0,9.09-.16,13.63-.17l13.63-.06-.51.51.06-11.52.45.46c-2.24,0-4.48,0-6.73-.05l-6.78-.12-13.75-.29Zm13.37-6.1,6.85-.12c2.29-.05,4.6,0,6.89-.05h.46v.46l.06,11.52v.52h-.52l-13.63-.07c-4.54,0-9.08-.11-13.63-.17h-.28v-.28c0-1.95.09-3.89.14-5.82l.14-5.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.85,312.71c0,1.92.11,3.81.13,5.7l-.28-.28c4.54-.06,9.09-.17,13.63-.17l13.63-.07-.51.52.05-11.52.46.46c-2.24,0-4.48,0-6.74-.06l-6.77-.11-13.75-.29Zm13.36-6.11,6.86-.11c2.29-.05,4.59,0,6.89-.06h.46v.46l.06,11.52v.51H320l-13.63-.06c-4.54,0-9.09-.12-13.63-.17h-.28v-.28c0-2,.09-3.9.13-5.82l.15-5.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,183.46c0,1.92.12,3.81.14,5.7l-.29-.28c4.55,0,9.09-.17,13.63-.17l13.63-.07-.51.52.06-11.52.45.46c-2.24,0-4.48,0-6.73-.06l-6.78-.11-13.75-.29Zm13.37-6.11,6.85-.11c2.29-.05,4.6,0,6.89-.06h.46v.46l.06,11.52v.52h-.52l-13.63-.06c-4.54,0-9.08-.12-13.63-.17h-.28v-.28c0-2,.09-3.9.14-5.82l.14-5.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.32,264.69V416.13h91.54V264.69Zm83.23,95.55H341.63V320.82h74.92Zm0-48.81H341.63V272h74.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.86,
    y: 264.69,
    width: 36.61,
    height: 151.43,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.63,
    y: 272.01,
    width: 17.8,
    height: 39.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,407h-75.2V368.66h75.2Zm-74.45-.75h73.7V369.41h-73.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.81,
    y: 379.61,
    width: 14.79,
    height: 7.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.34,386.9H372.8v-7.1h15.54Zm-14.79-.75h14v-5.6h-14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.63,
    y: 320.82,
    width: 17.8,
    height: 39.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.52,
    y: 105.85,
    width: 125,
    height: 7.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 113.27,
    width: 7.43,
    height: 24.55,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 113.27,
    width: 7.43,
    height: 7.59,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.6,
    y: 113.27,
    width: 7.43,
    height: 24.55,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.6,
    y: 113.27,
    width: 7.43,
    height: 7.59,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.41,
    y: 76.24,
    width: 47.3,
    height: 11.91,
    transform: "translate(172.26 -7.87) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.47,
    y: 52.66,
    width: 5.2,
    height: 11.91,
    transform: "translate(148.68 -31.45) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 62.88,
    width: 1.93,
    height: 11.91,
    transform: "translate(158.9 -21.22) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.21,
    y: 90.35,
    width: 5.2,
    height: 13.4,
    transform: "translate(187.85 6.24) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.59,
    y: 74.1,
    width: 55.18,
    height: 8.33,
    transform: "translate(178.44 -21.92) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.54,
    y: 63.97,
    width: 21.22,
    height: 5,
    transform: "translate(166.62 -33.68) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.44,
    y: 79.34,
    width: 55.18,
    height: 8.33,
    transform: "translate(99.43 -75.02) rotate(44.67)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 83.82,
    width: 21.22,
    height: 5,
    transform: "translate(102.24 -76.24) rotate(44.67)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.45,
    y: 77.83,
    width: 41.91,
    height: 14.14,
    transform: "translate(196.31 -26.51) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.46,
    y: 92.39,
    width: 3.91,
    height: 14.14,
    transform: "translate(210.87 -11.95) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.65,
    y: 87.12,
    width: 1.51,
    height: 14.14,
    transform: "translate(205.6 -17.22) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.53,
    y: 81.28,
    width: 39.39,
    height: 9.77,
    transform: "translate(165.39 6.94) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.39,
    y: 94.96,
    width: 3.67,
    height: 9.77,
    transform: "translate(179.07 20.62) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.39,
    y: 71.54,
    width: 3.67,
    height: 9.77,
    transform: "translate(155.65 -2.8) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.51,
    y: 76.6,
    width: 1.42,
    height: 9.77,
    transform: "translate(160.71 2.26) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.65,325.16c-12.44,16.85-25.41,36.4-28.57,57.53a.28.28,0,0,0,.55.11,124.71,124.71,0,0,1,5.5-16.92c8.18-2.25,16.21-4.1,20.5-12.22,4.38-8.34,3.83-19.22,3-28.31C113.56,324.86,112.9,324.84,112.65,325.16Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.25,365.72c5.59-12.54,12.77-25.13,21.89-35.44.06-.07.15,0,.1.1-6,7.34-10.51,15.34-14.94,23.48,4.12-4.18,8.63-7.93,12.53-12.36.08-.09.2,0,.13.12-3.88,4.65-8.11,9.7-13.15,13.14-1.36,2.5-2.72,5-4.11,7.51.34-.19.69-.36,1-.53.06,0,.11.06.05.09-.38.2-.76.4-1.16.57-.66,1.19-1.3,2.37-2,3.55C90.5,366.22,90.14,366,90.25,365.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.41,361.35A74.54,74.54,0,0,0,104,355c.08-.06.2,0,.12.12a50.57,50.57,0,0,1-9.53,6.49C94.39,361.66,94.26,361.43,94.41,361.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.64,379.55c0,.26.46.25.46,0,.06-7,0-13.95.11-20.94,1.78-3.6,5.61-5.59,8.27-8.47a37.83,37.83,0,0,0,5-6.91A49.7,49.7,0,0,0,102.2,324c.73-7.45-2.09-32-5.23-31.15-1.63.44-6.89,12.6-8.29,16.63a115.16,115.16,0,0,0-5,20.38C81.18,346.26,81.4,363.07,82.64,379.55Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,349.53l0,0c.38-8.81,2.37-17.7,4.22-26.24,2-9.2,4.34-17.86,9.08-26.06.08-.15.31,0,.23.14a97.06,97.06,0,0,0-7.29,20c.32-.49.71-1,1-1.43.13-.19.43,0,.3.18a12.74,12.74,0,0,1-1.48,2.09l-.06,0c-1.63,6.58-2.8,13.3-3.8,20a2.75,2.75,0,0,0,.22-.26s.14,0,.11.08l-.4.67c-.51,3.4-1,6.8-1.45,10.17,6.07-5.18,11.25-11.29,14.17-18.82,0,0,.07,0,0,0-2.86,7.81-7.37,14.75-14.31,19.48-.13.91-.26,1.82-.38,2.72,0,.19-.33.14-.33,0,0-.81,0-1.61.07-2.41A.2.2,0,0,1,82.59,349.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.45,336.78c4.63-6.92,9-13.63,12.35-21.28,0-.08.18,0,.15.07-2.86,7.59-6.86,15.29-12.27,21.39C85.57,337.08,85.35,336.92,85.45,336.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,313.8c1.92-3.4,4-6.71,5.75-10.17.06-.1.19,0,.15.09A53.36,53.36,0,0,1,91.9,314C91.77,314.14,91.49,314,91.6,313.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.86,315.27s0,.06,0,.06A0,0,0,1,1,90.86,315.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.93,359.43a70.92,70.92,0,0,1-1.62,13.71q.1.74.21,1.5A65.13,65.13,0,0,0,79,359.36a.48.48,0,0,0,0-.48h0a100.55,100.55,0,0,0-1.53-20.7c-2.16-12.79-6.86-25.06-15.78-34.65a.64.64,0,0,0-1,.21c-3.6,9.15-2.34,20.06.73,29.19a53,53,0,0,0,7.07,13.87C71.55,351.09,75.45,354.73,77.93,359.43Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.73,307.8c8.45,13.72,14.34,30,15.05,46.19,0,.28-.47.36-.51.07-.2-1.46-.42-2.9-.65-4.34h0c-3.49-3.35-7.08-6.89-9.59-11.07,0-.07.07-.16.12-.09a117.6,117.6,0,0,0,9.32,10.13c-.61-3.58-1.32-7.1-2.17-10.58l-.67-.78c-.15-.18.1-.43.25-.25l.2.22a120.78,120.78,0,0,0-4.42-14c-2.15-2.57-4.55-4.78-6.12-7.88a.06.06,0,0,1,.11-.06c1.26,1.77,2.48,3.55,3.91,5.19.57.65,1.2,1.26,1.79,1.9A109.31,109.31,0,0,0,62.41,308,.19.19,0,0,1,62.73,307.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.44,324.73c2.73,3.67,5.85,7.18,8.39,11,.07.11-.09.22-.18.14-3.26-3.07-6-7.25-8.39-11C64.18,324.71,64.36,324.62,64.44,324.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.21,336.56l.11.12c.09.08,0,.2-.12.12l-.12-.11C73,336.61,73.13,336.48,73.21,336.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49,334.17a42.09,42.09,0,0,0,8.92,20.93,22.34,22.34,0,0,0,7.23,5.64c3.13,1.55,6.41,3.34,9.65,4.61a62.86,62.86,0,0,1,3.42,12.14c.11-.36.21-.72.31-1.08-2.08-17.86-13.64-33.14-28.43-42.94A.72.72,0,0,0,49.49,334.17Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6,339.45c-.1-.09,0-.28.15-.19A60.51,60.51,0,0,1,73.6,362.48c.1.25-.23.46-.37.22-.69-1.21-1.39-2.38-2.1-3.53h0c-3.38-.63-6.58-3-9.08-5.27-.07-.06,0-.16.1-.1a20.42,20.42,0,0,0,4.27,3c1.38.7,2.86,1.14,4.29,1.7q-1.87-3-3.92-5.73a39.27,39.27,0,0,1-10.14-5.71c-.1-.07,0-.22.09-.16a103.08,103.08,0,0,0,9.43,5,83.88,83.88,0,0,0-6.65-7.76c-1.15-.61-2.31-1.22-3.43-1.86a.1.1,0,0,1,.08-.18,12.73,12.73,0,0,1,2.62,1.29C57.45,342.08,56.07,340.75,54.6,339.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.92,345.62a4.46,4.46,0,0,1,.56.41c.06.05,0,.12-.07.09a3.91,3.91,0,0,1-.59-.34A.09.09,0,0,1,54.92,345.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.11 416.18 61.58 416.18 64.85 379.28 65.57 371.14 98.11 371.14 98.83 379.28 102.11 416.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.83 379.28 64.85 379.28 65.57 371.14 98.11 371.14 98.83 379.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.63,
    y: 365.45,
    width: 36.42,
    height: 8.05,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-166"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "38.37 416.18 91.28 415.94 144.18 415.85 250 415.68 355.82 415.85 408.73 415.94 461.63 416.18 408.73 416.43 355.82 416.51 250 416.68 144.18 416.51 91.28 416.42 38.37 416.18",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-166"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 457.25,
    rx: 124.67,
    ry: 10.56,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-166"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.37,
    y: 54.53,
    width: 306.33,
    height: 244.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.2,299.92H139.87V54H447.2Zm-306.33-1H446.2V55H140.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.37,
    y: 54.53,
    width: 306.33,
    height: 11.61,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.08,60.33a2.63,2.63,0,1,1-2.63-2.62A2.62,2.62,0,0,1,150.08,60.33Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,60.33a2.62,2.62,0,1,1-2.62-2.62A2.62,2.62,0,0,1,160.78,60.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48,60.33a2.62,2.62,0,1,1-2.62-2.62A2.62,2.62,0,0,1,171.48,60.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.46,
    y: 218.34,
    width: 72.86,
    height: 50.89,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.36 213.07 398.32 213.07 398.32 218.34 374.04 218.34 375.36 213.07",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.63 269.24 398.49 269.24 403.5 222.57 330.64 222.57 325.63 269.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.06 217.73 404.02 217.73 403.5 222.57 379.22 222.57 381.06 217.73",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Duplicate--inject-166"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.85 275.25 223.47 275.22 223.51 200.28 266.86 200.3 281.88 214.59 281.85 275.25",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.85 275.25 223.47 275.22 223.51 200.28 266.86 200.3 281.88 214.59 281.85 275.25",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.86 200.3 281.88 214.59 266.85 214.58 266.86 200.3",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.86 200.3 281.88 214.59 266.85 214.58 266.86 200.3",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.2,
    y: 212.87,
    width: 32.46,
    height: 1.92,
    transform: "translate(490.74 427.78) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.19,
    y: 217.72,
    width: 32.46,
    height: 1.92,
    transform: "translate(490.74 437.5) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.19,
    y: 222.58,
    width: 32.46,
    height: 1.92,
    transform: "translate(490.73 447.21) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.19,
    y: 227.44,
    width: 47.56,
    height: 1.92,
    transform: "translate(505.82 456.94) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.19,
    y: 232.3,
    width: 47.56,
    height: 1.92,
    transform: "translate(505.81 466.65) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.18,
    y: 237.16,
    width: 47.56,
    height: 1.92,
    transform: "translate(505.8 476.37) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.18,
    y: 242.01,
    width: 47.56,
    height: 1.92,
    transform: "translate(505.8 486.08) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.18,
    y: 246.87,
    width: 47.56,
    height: 1.92,
    transform: "translate(505.79 495.79) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.18,
    y: 251.73,
    width: 47.56,
    height: 1.92,
    transform: "translate(505.78 505.51) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.17,
    y: 256.59,
    width: 47.56,
    height: 1.92,
    transform: "translate(505.78 515.22) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.17,
    y: 261.44,
    width: 47.56,
    height: 1.92,
    transform: "translate(505.77 524.94) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.17,
    y: 266.3,
    width: 47.56,
    height: 1.92,
    transform: "translate(505.76 534.65) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.63 171.33 305.25 171.3 305.29 96.36 348.63 96.38 363.66 110.67 363.63 171.33",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.63 171.33 305.25 171.3 305.29 96.36 348.63 96.38 363.66 110.67 363.63 171.33",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.63 96.38 363.66 110.67 348.62 110.66 348.63 96.38",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.63 96.38 363.66 110.67 348.62 110.66 348.63 96.38",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.97,
    y: 108.95,
    width: 32.46,
    height: 1.92,
    transform: "translate(654.35 219.99) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.97,
    y: 113.8,
    width: 32.46,
    height: 1.92,
    transform: "translate(654.34 229.7) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.97,
    y: 118.66,
    width: 32.46,
    height: 1.92,
    transform: "translate(654.33 239.41) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.97,
    y: 123.52,
    width: 47.56,
    height: 1.92,
    transform: "translate(669.43 249.14) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.96,
    y: 128.38,
    width: 47.56,
    height: 1.92,
    transform: "translate(669.42 258.85) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.96,
    y: 133.24,
    width: 47.56,
    height: 1.92,
    transform: "translate(669.41 268.57) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.96,
    y: 138.09,
    width: 47.56,
    height: 1.92,
    transform: "translate(669.4 278.28) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.96,
    y: 142.95,
    width: 47.56,
    height: 1.92,
    transform: "translate(669.4 288) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.95,
    y: 147.81,
    width: 47.56,
    height: 1.92,
    transform: "translate(669.39 297.71) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.95,
    y: 152.67,
    width: 47.56,
    height: 1.92,
    transform: "translate(669.38 307.43) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.95,
    y: 157.52,
    width: 47.56,
    height: 1.92,
    transform: "translate(669.37 317.14) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.95,
    y: 162.38,
    width: 47.56,
    height: 1.92,
    transform: "translate(669.37 326.86) rotate(-179.97)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.45 177.6 298.95 177.6 298.95 175.1 299.95 175.1 299.95 176.6 301.45 176.6 301.45 177.6",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,171.17h-1v-3.93h1Zm0-7.86h-1v-3.93h1Zm0-7.86h-1v-3.93h1Zm0-7.86h-1v-3.93h1Zm0-7.86h-1V135.8h1Zm0-7.86h-1v-3.93h1Zm0-7.86h-1v-3.93h1Zm0-7.86h-1v-3.93h1Zm0-7.86h-1v-3.93h1Zm0-7.86h-1V96.49h1Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.98 92.56 298.98 92.56 298.99 90.06 301.49 90.06 301.49 91.06 299.99 91.06 299.98 92.56",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.88,104.52l-2.78-2.65.69-.72,2.78,2.65Zm-5.57-5.29-2.78-2.65.69-.73L360,98.5Zm-5.57-5.3L351,91.28l.69-.72,2.78,2.65Zm-6.15-2.85h-3.84v-1h3.84Zm-7.68,0h-3.84v-1h3.84Zm-7.69,0h-3.84v-1h3.84Zm-7.68,0H320.7v-1h3.84Zm-7.69,0H313v-1h3.84Zm-7.68,0h-3.84v-1h3.84Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.96 110.19 368.96 110.19 368.96 108.4 367.67 107.17 368.35 106.44 369.96 107.97 369.96 110.19",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.92,171.32h-1V167.5h1Zm0-7.64h-1v-3.82h1Zm0-7.65h-1v-3.82h1Zm0-7.64h-1v-3.82h1Zm0-7.64h-1v-3.82h1Zm0-7.64h-1v-3.82h1Zm0-7.64h-1v-3.82h1Zm0-7.64h-1V114h1Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.92 177.64 367.42 177.64 367.42 176.64 368.92 176.64 368.92 175.14 369.92 175.14 369.92 177.64",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.54,177.63h-3.88v-1h3.88Zm-7.76,0H351.9v-1h3.88Zm-7.76,0h-3.88v-1H348Zm-7.77,0h-3.88v-1h3.88Zm-7.76,0h-3.88v-1h3.88Zm-7.76,0h-3.88v-1h3.88Zm-7.76,0h-3.88v-1H317Zm-7.76,0h-3.88v-1h3.88Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.15,200.71l-.58-.81,3.25-2.32.58.81Zm6.51-4.64-.58-.81,3.26-2.32.58.81Zm6.52-4.64-.58-.81,3.26-2.32.58.81Zm6.52-4.64-.58-.81,3.26-2.32.58.81Zm6.51-4.64-.58-.81,3.26-2.32.58.81Zm6.52-4.64-.57-.82h0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.66,
    cy: 110.67,
    r: 10.56,
    transform: "translate(172.74 439.38) rotate(-76.78)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.57,
    y: 104.15,
    width: 2.17,
    height: 13.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.57,
    y: 104.15,
    width: 2.17,
    height: 13.04,
    transform: "translate(474.33 -252.99) rotate(90)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-166"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "374.95 187.19 379.38 197.89 374.95 199.72 370.5 188.95 363.19 194.63 363.19 164.49 384.28 185.8 374.95 187.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.19,161.2a4,4,0,0,1-.27-1.51,4.07,4.07,0,0,1,.27-1.52,4.07,4.07,0,0,1,.27,1.52A4,4,0,0,1,363.19,161.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,162.28a4.4,4.4,0,0,1-2.14-2.14,4.4,4.4,0,0,1,2.14,2.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.5,164.89a3.88,3.88,0,0,1-1.52.27,3.83,3.83,0,0,1-1.51-.27,3.82,3.82,0,0,1,1.51-.26A4.06,4.06,0,0,1,359.5,164.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,167.5a4.12,4.12,0,0,1-.88,1.27,4.2,4.2,0,0,1-1.26.88,3.81,3.81,0,0,1,.88-1.26A4,4,0,0,1,360.58,167.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.88,164.89a4,4,0,0,1,1.51-.26,3.87,3.87,0,0,1,1.52.26,3.88,3.88,0,0,1-1.52.27A3.83,3.83,0,0,1,366.88,164.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.8,162.28a4.2,4.2,0,0,1,.88-1.26,4,4,0,0,1,1.26-.88,4,4,0,0,1-.88,1.26A3.91,3.91,0,0,1,365.8,162.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-166"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.76,
    y: 96.78,
    width: 47.31,
    height: 47.31,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.58,153.59H102.26V105.28h48.32Zm-47.32-1h46.32V106.28H103.26Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.01,
    y: 105.97,
    width: 4.81,
    height: 28.93,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.01,
    y: 105.97,
    width: 4.81,
    height: 28.93,
    transform: "translate(237.86 3.02) rotate(90)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.47,380.86s-1.23,48.24-1.23,48.27c0,8.92.22,16.74.69,20.77a.17.17,0,0,0,0,.07,6.21,6.21,0,0,0,.66,2.75l.06.06c2.66,1.79,73.93,3.64,76.43,2.86s.51-8-2.2-10.25-29.69-15.2-29.69-15.2L204,382Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.16,419.56s.08,9.54.08,9.57c0,8.92.22,16.74.69,20.77a.17.17,0,0,0,0,.07,12.27,12.27,0,0,0,.66,2.75l.06.06c2.66,1.79,73.93,3.64,76.43,2.86s.51-8-2.2-10.25-29.69-15.2-29.69-15.2l.05-9.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.57,430.22c-4.75-.78-10.52.07-14.06,3.51-.14.14.06.33.21.28a66.2,66.2,0,0,1,13.84-3.19A.3.3,0,0,0,207.57,430.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,432.2c-4.74-.78-10.51.07-14.05,3.52-.14.13.05.32.2.27A66.93,66.93,0,0,1,211,432.8.3.3,0,0,0,211,432.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.48,434.19c-4.75-.78-10.51.07-14.06,3.51-.13.13.06.33.21.28a66.2,66.2,0,0,1,13.84-3.19A.3.3,0,0,0,214.48,434.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.09,455.64c-2.51.78-73.77-1.07-76.44-2.87-1-.66-1.36-11.06-1.4-23.64v-.39l46,.68,0,.78s27,12.91,29.69,15.19S237.61,454.88,235.09,455.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.24,428.73v.41c.06,12.57.38,23,1.41,23.64,1.21.81,16.66,1.64,33.35,2.23,20,.71,41.73,1.06,43.1.64,2.51-.77.49-8-2.21-10.26S203.2,430.2,203.2,430.2l0-.78-15.33-.23Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.36,452.86c-12-.61-60.48-1.92-72.4-1.61-.09,0-.1.07,0,.08,11.89.86,60.37,1.78,72.4,1.73C234.61,453.06,234.61,452.87,234.36,452.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.91,429.19C189,436.9,190.74,448.25,192,455c20,.71,41.73,1.06,43.1.64,2.51-.77.49-8-2.21-10.26S203.2,430.2,203.2,430.2l0-.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,429.4l51.57.49s2.93-84,3.15-112c.25-32-1.56-127.92-1.56-127.92H167.7s-10.34,21.14-4.43,44.94l1.63,85.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92,420.36A37.52,37.52,0,0,1,161,420c1.52-.11,3-.22,4.57-.29,2.93-.12,5.87-.17,8.8-.19,5.92,0,11.85,0,17.77.21,3.36.11,6.73.24,10.09.43a.11.11,0,0,1,0,.22c-5.87.21-11.74.3-17.62.41s-11.74.23-17.6.12c-1.69,0-3.37-.05-5-.14s-3.4,0-5.05-.25C156.85,420.55,156.8,420.39,156.92,420.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,374c.6-13.89,1-27.78,1.42-41.67q1.14-41.69.6-83.38c-.19-15.6-.61-31.19-1.07-46.77,0-.18.26-.17.27,0,1.48,27.91,2,55.87,2.07,83.81s-.55,55.6-1.92,83.36c-.77,15.59-1.72,31.18-3.19,46.71a.11.11,0,0,1-.21,0C199.56,402.05,200.35,388,201,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.64,388.52s.39,46.63.39,46.66c0,8.92.21,16.74.68,20.77a.2.2,0,0,0,0,.07,6.31,6.31,0,0,0,.67,2.75l.05.06c2.66,1.78,73.93,3.64,76.44,2.86s.5-8-2.21-10.25S260,436.24,260,436.24l-.83-46.6Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,425.61s.08,9.54.08,9.57c0,8.92.21,16.74.68,20.77a.2.2,0,0,0,0,.07,12.2,12.2,0,0,0,.67,2.75l.05.06c2.66,1.78,73.93,3.64,76.44,2.86s.5-8-2.21-10.25S260,436.24,260,436.24l0-9.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.35,436.27c-4.75-.78-10.51.07-14.05,3.51-.14.14,0,.33.2.28a66.35,66.35,0,0,1,13.84-3.19A.3.3,0,0,0,264.35,436.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81,438.25c-4.75-.78-10.52.07-14.06,3.52-.14.13.06.32.21.27a66.84,66.84,0,0,1,13.84-3.19A.3.3,0,0,0,267.81,438.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.26,440.24c-4.74-.78-10.51.07-14.05,3.51-.14.13.05.33.21.28a66.06,66.06,0,0,1,13.84-3.19A.3.3,0,0,0,271.26,440.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.88,461.69c-2.51.78-73.78-1.07-76.44-2.87-1-.66-1.36-11.06-1.41-23.64v-.39l46,.68,0,.78s27,12.91,29.68,15.19S294.39,460.93,291.88,461.69Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.14,458.91c-12-.61-60.48-1.92-72.39-1.61-.1,0-.1.07,0,.08,11.88.86,60.37,1.78,72.39,1.73C291.39,459.11,291.4,458.92,291.14,458.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.07,239.34s21.16,66.69,21.54,79c.33,10.44-1,117.66-1,117.66l53.56.32S259.64,326.93,258.8,316c-1.56-20.36-19.4-76.26-32.16-126H168.9s.5,26.08,12.36,44.94C181.26,234.93,186.63,237.41,190.07,239.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45,426.08c6.18-.18,12.6-.36,18.79-.21s12.29.25,18.42.61c3.47.21,6.94.33,10.41.67a.1.1,0,0,1,0,.19c-6.18.36-12.39.28-18.58.23s-12.29-.12-18.43-.41c-3.47-.16-6.94-.33-10.41-.57C213.27,426.56,213.07,426.09,213.45,426.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,221.4c1.91,6.38,3.52,12.84,5.23,19.27s3.44,13,5.14,19.45c3.3,12.54,6.57,25.11,9,37.84a228.79,228.79,0,0,1,4.28,38.79c.29,13.28,0,26.57-.08,39.85s-.2,26.7-.43,40c0,1.66-.07,3.32-.13,5,0,.16-.24.15-.25,0-.35-13.28-.16-26.58-.12-39.86s.22-26.57.11-39.85a240,240,0,0,0-3.41-39.34c-2.24-12.78-5.39-25.38-8.65-37.93q-2.79-10.74-5.6-21.48c-1.87-7.2-3.87-14.4-5.52-21.66A.2.2,0,0,1,225.16,221.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.32,240.63a48.28,48.28,0,0,1-8-.72,79.12,79.12,0,0,1-7.7-2.14,60.14,60.14,0,0,0-7.56-1.23,26.55,26.55,0,0,1-7.4-2.21.1.1,0,0,0-.09.17,45.91,45.91,0,0,0,7.09,3.08c2.54.8,5.2.91,7.77,1.54a64.06,64.06,0,0,0,7.93,1.82,28.61,28.61,0,0,0,7.95-.13C203.45,240.79,203.42,240.63,203.32,240.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7,293.68c-.51-2-1-4-1.52-5.93-1.09-4-2.19-8-3.39-11.91-2.39-7.84-4.65-15.73-7.18-23.53-1.43-4.43-2.72-8.91-4.4-13.24a.09.09,0,0,0-.17.05c.84,4,2,8,3.11,12s2.22,7.95,3.37,11.91c2.29,7.88,4.52,15.77,7,23.59.7,2.19,1.41,4.37,2.17,6.55s1.38,4.51,2.31,6.67a.1.1,0,0,0,.19-.06C207.85,297.71,207.22,295.7,206.7,293.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,127.17c-3.83.74-10.92-5.85-13.3-10.66-.16-.33.47-3.71,1.05-7.85.34-2.52.66-5.32.77-7.91l16,4.61a41.2,41.2,0,0,0-2,9.86,5.15,5.15,0,0,0,.07,1.06s0,.11,0,.18C218.1,118.49,218.9,126.45,215.19,127.17Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.84,116.28s0,.12,0,.18a10.19,10.19,0,0,1-1.67,0c-9.52-.78-11.57-11.56-12-15.59l15.58,4.48a41,41,0,0,0-2,9.85A6,6,0,0,0,217.84,116.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.9,80.93c-2.07,5.64,0,22.4,3.91,26.32,5.62,5.69,15.29,6.75,20.24-.12,4.8-6.65,1.67-28.43-2.71-32C215.9,69.76,204,72.59,200.9,80.93Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.15,91.88s-.09.06-.08.11c.16,1.12.15,2.44-.84,2.93,0,0,0,.07,0,.06C217.48,94.67,217.48,92.92,217.15,91.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,90.81c-1.83,0-1.58,3.72.11,3.66S217.55,90.76,216,90.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.52,91.43c0-.05.09,0,.09.09,0,1.14.28,2.43,1.33,2.74,0,0,0,.07,0,.07C223.68,94.23,223.38,92.51,223.52,91.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.45,90.17c1.82-.26,2.21,3.39.53,3.64S222.93,90.39,224.45,90.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.45,89.23a14.2,14.2,0,0,0,1.39-.6,2.41,2.41,0,0,0,1.29-.87.78.78,0,0,0-.19-.93,1.92,1.92,0,0,0-1.95-.07,2.84,2.84,0,0,0-1.54,1.33A.83.83,0,0,0,214.45,89.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.74,88.23a12.45,12.45,0,0,1-1.48-.28,2.41,2.41,0,0,1-1.46-.57.79.79,0,0,1,0-.95,1.94,1.94,0,0,1,1.89-.49,2.84,2.84,0,0,1,1.8,1A.83.83,0,0,1,225.74,88.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.65,102.27c.29.25.58.6,1,.6a2.89,2.89,0,0,0,1.2-.37,0,0,0,0,1,.05.06,1.51,1.51,0,0,1-1.4.71,1.21,1.21,0,0,1-1-.94C216.52,102.27,216.6,102.24,216.65,102.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.61,98.79a3.85,3.85,0,0,0,2.69,1.55,5.05,5.05,0,0,0,1.4,0l.26,0,.25-.06a.28.28,0,0,0,.21-.27h0s0-.07,0-.11h0v-.1c0-.87-.21-2.2-.21-2.2.33.14,2,.76,1.95.31a58.43,58.43,0,0,0-2.29-11.59.11.11,0,0,0-.21,0c.32,3.64,1.28,7.19,1.66,10.84a6.53,6.53,0,0,0-1.86-.43c-.12,0,.38,2.55.37,2.94a.1.1,0,0,1,0,0,5.35,5.35,0,0,1-4.08-1C217.62,98.63,217.53,98.71,217.61,98.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,99.9a4.56,4.56,0,0,1-1.74,1.55,2.08,2.08,0,0,1-1.24.16c-.92-.18-1-1-.89-1.73a5,5,0,0,1,.34-1.12A5.92,5.92,0,0,0,221.15,99.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.41,101.45a2.08,2.08,0,0,1-1.24.16c-.92-.18-1-1-.89-1.73A2.12,2.12,0,0,1,219.41,101.45Z",
    style: {
      fill: "#ff97b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,75.9c.18,2.24.57,9.2-.32,10.75s-2.71,5.11-3.8,5.78c-.46-4.62-.33-9.09.56-11.5A11.82,11.82,0,0,1,204.47,75.9Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.71,80.52a5.55,5.55,0,0,1-4.87,2.35,5.67,5.67,0,0,1-4.66-3s-.11,0-.08,0a5.61,5.61,0,0,0,4.7,3.37,5.73,5.73,0,0,0,5-2.72C218.87,80.52,218.76,80.44,218.71,80.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.7,67.41a8.74,8.74,0,0,0-6.93,4.71,6.24,6.24,0,0,0-.23,4.1c0,.06.13,0,.12,0a6.84,6.84,0,0,1,2.63-6.46A8.84,8.84,0,0,1,215,68.08a5.6,5.6,0,0,1,3.21,2.11c.07.11.3,0,.24-.1C217.36,68.17,214.6,67.07,211.7,67.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,72.6a7.1,7.1,0,0,0-3.37-3.51c-2.08-1-4.29-.65-6.47-.21-.06,0,0,.1,0,.09a9.77,9.77,0,0,1,5.57.1,7,7,0,0,1,3.53,3.08,6.8,6.8,0,0,1-2,8.67,6.9,6.9,0,0,1-5.37,1.06c-.07,0-.12.09,0,.11a7,7,0,0,0,8.23-4.3A7.09,7.09,0,0,0,231,72.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,84.28s-3.56-5.46-1.31-9c1.27-2,6.08-2.2,6.08-2.2A8.67,8.67,0,0,1,210,68.93c3.93-1.27,8.9.64,8.9.64s3.6-2.51,7.35-.8c5.22,2.4,5.27,10,.49,12.9-3.36,2-8.4-.66-8.4-.66-.45.1-4.89,3.35-8.82-.52,0,0-2.65,2.82-5.4,1.25A4.2,4.2,0,0,1,200,84.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.4,98.1a4.66,4.66,0,1,1,5.09-5.33h0a4.67,4.67,0,0,1-3.93,5.31A5,5,0,0,1,215.4,98.1Zm.88-8.66a3.81,3.81,0,0,0-1,0,4,4,0,1,0,1,0Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.11,97.88c-1.78-.18-3.21-2.16-3.25-4.6A5.6,5.6,0,0,1,223.8,90a3.1,3.1,0,0,1,2.46-1.44,3.06,3.06,0,0,1,2.51,1.37,5.54,5.54,0,0,1,1,3.24c0,2.57-1.49,4.69-3.4,4.72Zm.4-8.68a1,1,0,0,0-.24,0,2.48,2.48,0,0,0-2,1.17,4.91,4.91,0,0,0-.82,2.91c0,2.23,1.33,4,2.91,4s2.82-1.86,2.79-4.09a5,5,0,0,0-.92-2.88A2.55,2.55,0,0,0,226.51,89.2Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.34,93.32l-.41-.48c.7-.6,2.32-1.43,3.48-.23l-.45.44C221.92,92,220.4,93.26,220.34,93.32Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.57,94.85l-.55-.28c.13-.26,1.3-2.55,2.69-2.8s9.67.42,10,.45l0,.62c-2.4-.19-8.87-.64-9.87-.46S199.89,94.22,199.57,94.85Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.69,94.64s-3.56-5.5-6-4.25.06,9.14,2.88,10.3a2.9,2.9,0,0,0,3.95-1.42Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.43,92.64s-.05,0,0,.07c2,.88,3,2.78,3.64,4.74a1.61,1.61,0,0,0-2.39-.53s0,.12.05.11a1.79,1.79,0,0,1,1.95.7,8,8,0,0,1,.89,1.62c.09.18.41.1.35-.11v0C203,96.64,201.17,93,198.43,92.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.07,201.17c.15.21,74.24,7.57,75,6.87,1-1-2.73-75.19-15.83-90.46-3.22-3.76-14.68-8.35-18.49-6-9.89,6-16.07,19.59-20,27.51-2.93,5.87-6.73,16-10.25,26.38C163.64,182.55,158.52,200.41,159.07,201.17Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.72,140.1a11.17,11.17,0,0,0-.64,3.17,10.78,10.78,0,0,0,1.42-2.89,11.67,11.67,0,0,0,.64-3.17A10.78,10.78,0,0,0,203.72,140.1Zm-30,18.92a12,12,0,0,0-.63,3.16,10.72,10.72,0,0,0,1.42-2.88,10.89,10.89,0,0,0,.63-3.17A11.75,11.75,0,0,0,173.72,159Zm42.91,44a11.37,11.37,0,0,0-.63,3.16,11,11,0,0,0,1.43-2.89,12.31,12.31,0,0,0,.63-3.16A11,11,0,0,0,216.63,203Zm-37,.18,0,.14.85.07a11,11,0,0,0,.61-3.1A10.9,10.9,0,0,0,179.64,203.19ZM160.37,197a12.15,12.15,0,0,0-.64,3.16,10.44,10.44,0,0,0,1.43-2.9,10.69,10.69,0,0,0,.63-3.16A12.19,12.19,0,0,0,160.37,197Zm38.06-18.43a11.75,11.75,0,0,0-.64,3.16,10.53,10.53,0,0,0,1.43-2.89,11.67,11.67,0,0,0,.63-3.16A11.25,11.25,0,0,0,198.43,178.57Zm-10.67-51.84a10.69,10.69,0,0,0-.63,3.16,11.61,11.61,0,0,0,1.41-2.9,10.89,10.89,0,0,0,.64-3.15A11.25,11.25,0,0,0,187.76,126.73Zm39.15,13.62,0,0a10.57,10.57,0,0,0-3.15-.64,11.12,11.12,0,0,0,2.89,1.43c.18,0,.35.11.53.15C227.06,141,227,140.65,226.91,140.35Zm-49,41.22a11.38,11.38,0,0,0-3.16-.64,10.56,10.56,0,0,0,2.9,1.42,10.89,10.89,0,0,0,3.15.64A11.09,11.09,0,0,0,178,181.57ZM234,204.48a10.88,10.88,0,0,0-3.16-.63,11.3,11.3,0,0,0,2.9,1.42l.46.14c0-.27,0-.55,0-.85ZM206.6,193.35a11.16,11.16,0,0,0-3.17-.63,11.27,11.27,0,0,0,2.9,1.41,10.83,10.83,0,0,0,3.17.64A11.64,11.64,0,0,0,206.6,193.35Zm20.3-22.2a11.59,11.59,0,0,0-3.15-.63,11.09,11.09,0,0,0,2.89,1.42,11.53,11.53,0,0,0,3.16.64A11.34,11.34,0,0,0,226.9,171.15Zm-29.83-17a10.88,10.88,0,0,0-3.16-.63,11.11,11.11,0,0,0,2.9,1.41,10.7,10.7,0,0,0,3.16.64A11.31,11.31,0,0,0,197.07,154.15Zm-25.55,40.53a11.47,11.47,0,0,0-1.78-2.68,11,11,0,0,0,1,3.05,11.16,11.16,0,0,0,1.78,2.68A11.56,11.56,0,0,0,171.52,194.68Zm32-76.84a11,11,0,0,0-1.79-2.68,12.66,12.66,0,0,0,2.82,5.73A11.2,11.2,0,0,0,203.53,117.84Zm15.3,34.94a11.36,11.36,0,0,0-1.78-2.68,12.42,12.42,0,0,0,2.83,5.73A11.35,11.35,0,0,0,218.83,152.78ZM197.6,203.49a11.26,11.26,0,0,0-1.78-2.68,11.4,11.4,0,0,0,1,3.06c.21.4.43.81.68,1.2l.75.07A12.5,12.5,0,0,0,197.6,203.49Zm18.18-22a11.47,11.47,0,0,0-1.78-2.68,11.11,11.11,0,0,0,1,3,11.74,11.74,0,0,0,1.78,2.69A11.28,11.28,0,0,0,215.78,181.54ZM187.24,168a11.46,11.46,0,0,0-1.79-2.69,12.28,12.28,0,0,0,2.84,5.74A11.71,11.71,0,0,0,187.24,168Zm-20.59,5.91c-.11.36-.23.71-.34,1.07l.29-.13a11.37,11.37,0,0,0,2.68-1.78A10.11,10.11,0,0,0,166.65,173.89ZM189,190.39a11.58,11.58,0,0,0-2.7,1.78,12.37,12.37,0,0,0,5.74-2.82A11,11,0,0,0,189,190.39Zm-5.36-45.61a11.62,11.62,0,0,0-2.67,1.78,11.38,11.38,0,0,0,3.06-1,11.66,11.66,0,0,0,2.68-1.8A11.72,11.72,0,0,0,183.67,144.78Zm42.3,47.9a11.52,11.52,0,0,0-2.69,1.78,11,11,0,0,0,3.05-1,10.78,10.78,0,0,0,2.68-1.78A10.82,10.82,0,0,0,226,192.68Zm-15.39-27.22a11.85,11.85,0,0,0-2.69,1.78,11.31,11.31,0,0,0,3.05-1,10.91,10.91,0,0,0,2.68-1.79A11.5,11.5,0,0,0,210.58,165.46ZM218.36,126a11.9,11.9,0,0,0-2.68,1.78,12.47,12.47,0,0,0,5.75-2.82A11,11,0,0,0,218.36,126Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8,132.16c10.84,16.25,32.54,45.61,46.4,46.58,14.7,1,34.05-15,42.37-20,3.52-2.1-16.36-24.53-20.56-23.25s-16.81,12.05-20.07,12.41S237.2,130.19,223,120.67C206.35,109.47,204,119,212.8,132.16Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.35,115.26c1.85,3.36-6.81,7.21-6.81,7.21a7.08,7.08,0,0,1,4.37,2c2,2.14-.52,6.17-.52,6.17a8.74,8.74,0,0,1,4.27,2.85c1.68,2.24-.25,6.67-.25,6.67a7.61,7.61,0,0,1,2.17,4.87c.11,4.91-6.15,9-10.1,11.68S294.57,163,292,164l-16-25s14.34-17,19.44-19.42C299.74,117.47,317.53,110.13,320.35,115.26Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42,122.41c-5.09,1.11-9.91,3.44-14.53,5.74a.09.09,0,0,0,.08.16c4.57-2.34,9.88-3.51,14.53-5.67C313.63,122.59,313.56,122.38,313.42,122.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.09,130.38a12.93,12.93,0,0,0-3.21,1.52c-1.1.61-2.19,1.25-3.27,1.9-2.15,1.3-4.28,2.66-6.37,4.07-.09.07,0,.22.09.16,2.15-1.29,4.32-2.56,6.52-3.76,1.1-.61,2.21-1.2,3.33-1.79a15.66,15.66,0,0,0,3.06-1.8A.17.17,0,0,0,317.09,130.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.32,140.22a9.53,9.53,0,0,0-2.82,1.52c-1,.62-1.94,1.23-2.92,1.83-1.95,1.21-3.91,2.42-5.9,3.56a.09.09,0,0,0,.08.16c2-1.15,4.08-2.27,6.1-3.44,1-.57,2-1.14,3-1.73a8.72,8.72,0,0,0,2.55-1.8A.06.06,0,0,0,321.32,140.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.72,138.18,294.66,168s-26,16.4-40.24,11.29-36.59-35.5-44-49.39-1.21-19.33,12-10.28,36.69,26.63,37.61,27S274.72,138.18,274.72,138.18Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,126a11.9,11.9,0,0,0-2.68,1.78,12.47,12.47,0,0,0,5.75-2.82A11,11,0,0,0,218.36,126ZM261.86,167a11.22,11.22,0,0,0-2.69,1.78,12.39,12.39,0,0,0,5.74-2.83A10.91,10.91,0,0,0,261.86,167Zm14.84-25.88a12,12,0,0,0-1.21.53,11.27,11.27,0,0,0-2.7,1.78,11.33,11.33,0,0,0,3.07-1c.42-.22.83-.45,1.23-.71Zm-32.21,4.53a11.42,11.42,0,0,0-1.78-2.69,12.5,12.5,0,0,0,2.82,5.74A10.89,10.89,0,0,0,244.49,145.68Zm8.55,32a11.9,11.9,0,0,0-1.78-2.68,11.33,11.33,0,0,0,1,3.05l.23.43c.36.17.72.33,1.06.47C253.42,178.51,253.23,178.1,253,177.68Zm21.06-21a11.51,11.51,0,0,0-1.79-2.68,11.33,11.33,0,0,0,1,3.05,11.79,11.79,0,0,0,1.78,2.68A11.2,11.2,0,0,0,274.1,156.65Zm-28.79,6.43a11.37,11.37,0,0,0-3.16-.63,11.64,11.64,0,0,0,2.9,1.42,11.9,11.9,0,0,0,3.17.64A11.4,11.4,0,0,0,245.31,163.08Zm46.57.74c-.46-.22-.94-.4-1.42-.58a11,11,0,0,0-3.16-.62,12,12,0,0,0,2.9,1.41,13.24,13.24,0,0,0,2.19.55Zm-65-23.49a10.57,10.57,0,0,0-3.15-.64,11.12,11.12,0,0,0,2.89,1.43,11.51,11.51,0,0,0,3.16.62A11,11,0,0,0,226.86,140.33Zm6,16.65a11.43,11.43,0,0,0-.62,3.16,12.43,12.43,0,0,0,2-6A11.45,11.45,0,0,0,232.89,157Zm27.43-4a11.17,11.17,0,0,0-.64,3.17,11.12,11.12,0,0,0,1.43-2.89,11.51,11.51,0,0,0,.63-3.17A10.78,10.78,0,0,0,260.32,153Zm13.57,19.94a12.49,12.49,0,0,0-.64,3.16,10.39,10.39,0,0,0,1.43-2.89,10.69,10.69,0,0,0,.63-3.16A12.5,12.5,0,0,0,273.89,172.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.92,156.18c-1.35-2.16-2.76-4.29-4.16-6.42-.68-1-1.34-2-2.05-3s-1.45-2.24-2.29-3.26a.07.07,0,0,0-.12.08c.56,1.19,1.31,2.32,1.95,3.47s1.23,2.11,1.86,3.16c1.32,2.19,2.63,4.37,4,6.52,2.73,4.32,5.58,8.54,8.48,12.74a.09.09,0,0,0,.16-.1C283.21,164.89,280.63,160.5,277.92,156.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.14,158.17c-1.86-2.46-8.88-12.4-10.15-14.26-2.56-3.74-5.08-7.52-7.64-11.27,0,0-.09,0-.07,0,1.24,2.43,2.59,4.8,4,7.12l-.38-.43c-.78-.86-1.6-1.69-2.42-2.52-.05,0-.13,0-.09.08.75.92,1.49,1.86,2.28,2.75.5.57,1,1.1,1.55,1.65.63,1,1.29,2,1.95,3,1.29,1.9,8.25,11.86,10.8,14C230.08,158.36,230.21,158.26,230.14,158.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,114.43c-5.52-4.05-21.72-7.79-29-4.3-9.14,4.41-21.45,35.75-18.32,38.16,5.59,4.29,29.3-11.56,35-18.65S214,114.43,214,114.43Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,108.87a9.49,9.49,0,0,0-1.3,1,11,11,0,0,0,3-1,.75.75,0,0,0,.13-.06C191.23,108.76,190.59,108.81,190,108.87Zm-10.67,8.46c-.19-.35-.37-.7-.58-1-.16.22-.31.46-.49.7.1.23.21.47.32.7a11.68,11.68,0,0,0,1.78,2.68A11.2,11.2,0,0,0,179.32,117.33Zm24.21.51a11,11,0,0,0-1.79-2.68,12.66,12.66,0,0,0,2.82,5.73A11.2,11.2,0,0,0,203.53,117.84ZM173.1,134.62a11.5,11.5,0,0,0-3.17-.62,11.58,11.58,0,0,0,2.89,1.42,11.3,11.3,0,0,0,3.17.63A11.79,11.79,0,0,0,173.1,134.62Zm14.66-7.89a10.69,10.69,0,0,0-.63,3.16,11.61,11.61,0,0,0,1.41-2.9,10.89,10.89,0,0,0,.64-3.15A11.25,11.25,0,0,0,187.76,126.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.33,123.53c-1.23,1-2.5,1.91-3.72,2.91,1.73-2,3.48-4.08,5.15-6.18.06-.07,0-.17-.12-.11a89.41,89.41,0,0,0-6.24,6.52c-2.08,2.26-4.17,4.51-6.37,6.66a62,62,0,0,1-6.94,6,66.73,66.73,0,0,1-8.28,5q-2.43,1.26-4.91,2.41a37.87,37.87,0,0,1-5.48,2c-.35.09-.14.22,0,.2a27.25,27.25,0,0,0,4.65-1.46c1.56-.63,3.13-1.25,4.68-1.9a57.63,57.63,0,0,0,8.64-4.33c5.35-3.38,9.56-8,13.56-12.84l.23-.28c.73-.6,1.45-1.21,2.15-1.85,1-.92,2.05-1.79,3.14-2.62C208.54,123.6,208.42,123.45,208.33,123.53Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateCuate);
export default __webpack_public_path__ + "static/media/duplicate-cuate.599c4fd5265f3bbf5b534230cc0337eb.svg";
export { ForwardRef as ReactComponent };